module.exports = "/_next/static/images/CartAbandonmentMobile-f6eca5f9e02103308491a4a30ac878f9.webp";